__turbopack_context__.v({
  "className": "archivo_7521bf0-module__5Qjm3a__className",
});
